import { render, staticRenderFns } from "./JsaDelete.vue?vue&type=template&id=14912e76"
import script from "./JsaDelete.vue?vue&type=script&lang=js"
export * from "./JsaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports